import React from 'react';
import {
  BrowserRouter as Router, Route, Redirect, Switch,
} from 'react-router-dom';
import SAVLovebox from '../components/sav-lovebox/sav-lovebox';
import LoginPage from '../components/login/login';
import AdminPage from '../components/admin/admin';
import ManagerPage from '../components/manager/manager';
import ModeratorPage from '../components/moderator/moderator';
import PremiumModeratorPage from '../components/premium_moderator/moderator';
import TagsPage from '../components/tags/tags';
import TemplatesPage from '../components/templates/templates';
import TemplatesBatchPage from '../components/templates/batch_templates';
import ChannelsPage from '../components/channels/ChannelsPage';
import AmbassadorPage from '../components/ambassador/ambassador';
import LovepixPage from '../components/lovepix/lovepix';
import OTAPage from '../components/ota/ota';
import TemplatesManagerHome from '../components/templates-manager/templates-manager';
import UserInfoPage from '../components/user-info/user-info';
import LoveboxInfoPage from '../components/lovebox-info/lovebox-info-page';
import KeepInfoPage from '../components/keep-info/keep-info-page';
import KeepDashboardPage from '../components/keep-info/keep-dashboard';
import PhotoBookInfoPage from '../components/photobook/photobook-info';
import PhotoBookManagerPage from '../components/photobook/photobook-manager';

function AdminRouter({ ...rest }) {
  return (
    <Route
      {...rest}
      render={() => (
        rest.admin
          ? <AdminPage />
          : <Redirect to="/" />
      )}
    />
  );
}

function ModeratorRouter({ ...rest }) {
  return (
    <Route
      {...rest}
      render={() => (
        rest.moderator
          ? <ModeratorPage />
          : <Redirect to="/" />
      )}
    />
  );
}

function PremiumModeratorRouter({ ...rest }) {
  return (
    <Route
      {...rest}
      render={() => (
        rest.moderator
          ? <PremiumModeratorPage />
          : <Redirect to="/" />
      )}
    />
  );
}

function TagsRouter({ ...rest }) {
  return (
    <Route
      {...rest}
      render={() => (
        rest.moderator
          ? <TagsPage />
          : <Redirect to="/" />
      )}
    />
  );
}

function TemplatesRouter({ ...rest }) {
  return (
    <Route
      {...rest}
      render={() => (
        rest.designer
          ? <TemplatesPage />
          : <Redirect to="/" />
      )}
    />
  );
}

function TemplatesBatchRouter({ ...rest }) {
  return (
    <Route
      {...rest}
      render={() => (
        rest.designer
          ? <TemplatesBatchPage />
          : <Redirect to="/" />
      )}
    />
  );
}

function ChannelsRouter({ ...rest }) {
  return (
    <Route
      {...rest}
      render={() => (
        rest.designer
          ? <ChannelsPage />
          : <Redirect to="/" />
      )}
    />
  );
}

function TemplatesManagerRouter({ ...rest }) {
  return (
    <Route
      {...rest}
      render={() => (
        rest.templatesManager
          ? <TemplatesManagerHome />
          : <Redirect to="/" />
      )}
    />
  );
}

function LovepixRouter({ ...rest }) {
  return (
    <Route
      {...rest}
      render={() => (
        rest.lovepix
          ? <LovepixPage />
          : <Redirect to="/" />
      )}
    />
  );
}

function AmbassadorRouter({ ...rest }) {
  return (
    <Route
      {...rest}
      render={() => (
        rest.ambassador
          ? <AmbassadorPage />
          : <Redirect to="/" />
      )}
    />
  );
}

const OTARouter = ({ ...rest }) => (
  <Route {...rest} render={() => (rest.ota ? <OTAPage /> : <Redirect to="/" />)} />
);

const UserInfoRouter = ({ ...rest }) => (
  <Route {...rest} render={(props) => (rest.savagent ? <UserInfoPage {...props} /> : <Redirect to="/" />)} />
);

const LoveboxInfoRouter = ({ ...rest }) => (
  <Route {...rest} render={(props) => (rest.savagent ? <LoveboxInfoPage {...props} isLoveboxBatchManager={!!rest.loveboxBatchManager} /> : <Redirect to="/" />)} />
);

const KeepInfoRouter = ({ ...rest }) => (
  <Route {...rest} render={(props) => (rest.savagent ? <KeepInfoPage {...props} /> : <Redirect to="/" />)} />
);

const KeepDashboardRouter = ({ ...rest }) => (
  <Route {...rest} render={(props) => (rest.savagent ? <KeepDashboardPage {...props} /> : <Redirect to="/" />)} />
);

const PhotoBookInfoRouter = ({ ...rest }) => (
  <Route {...rest} render={(props) => (rest.savagent ? <PhotoBookInfoPage {...props} /> : <Redirect to="/" />)} />
);

const PhotoBookManagerRouter = ({ ...rest }) => (
  <Route {...rest} render={(props) => (rest.savagent ? <PhotoBookManagerPage {...props} /> : <Redirect to="/" />)} />
);

function ManagerRouter({ ...rest }) {
  return (
    <Route
      {...rest}
      render={() => (
        rest.manager
          ? <ManagerPage />
          : <Redirect to="/" />
      )}
    />
  );
}

// redirect on / when logged in
function LoginRouter({ ...rest }) {
  return (
    <Route
      {...rest}
      render={() => (
        rest.token
          ? <Redirect to="/" />
          : <LoginPage {...rest} />
      )}
    />
  );
}

function Authenticated({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => (
        rest.token
          ? <Component {...props} />
          : <Redirect to="/login" />
      )}
    />
  );
}

const RouterSAV = ({ onLogin, token, roles }) => (
  <Router>
    <Switch>
      <LoginRouter
        exact
        path="/login"
        token={token}
        onLogin={onLogin}
      />
      <AdminRouter
        exact
        path="/admin"
        token={token}
        admin={roles.admin}
      />
      <ManagerRouter
        exact
        path="/manager"
        token={token}
        manager={roles.manager}
      />
      <ModeratorRouter
        exact
        path="/moderate/stickers"
        token={token}
        moderator={roles.admin}
      />
      <PremiumModeratorRouter
        exact
        path="/moderate/premium_gifs"
        token={token}
        moderator={roles.admin || roles.designer}
      />
      <TagsRouter
        exact
        path="/tags"
        token={token}
        moderator={roles.admin}
      />
      <TemplatesRouter
        exact
        path="/templates/create/:templateId?/:duplicate?"
        token={token}
        designer={roles.designer}
      />
      <TemplatesBatchRouter
        exact
        path="/templates/createbatch"
        token={token}
        designer={roles.designer}
      />
      <ChannelsRouter
        exact
        path="/channels"
        token={token}
        designer={roles.designer}
      />
      <TemplatesManagerRouter
        exact
        path="/templates/manage"
        token={token}
        templatesManager={roles.templatesManager}
      />
      <AmbassadorRouter
        exact
        path="/ambassador"
        token={token}
        ambassador={roles.ambassador}
      />
      <LovepixRouter
        exact
        path="/lovepix/send_photo"
        token={token}
        lovepix={roles.lovepix}
      />
      <OTARouter
        exact
        path="/lovepix/ota"
        token={token}
        ota={roles.ota}
      />
      <UserInfoRouter
        exact
        path="/user/:email?/:relation?"
        token={token}
        savagent={roles.savagent}
      />
      <PhotoBookManagerRouter
        exact
        path="/photobook/manage"
        token={token}
        savagent={roles.savagent}
      />
      <PhotoBookInfoRouter
        exact
        path="/photobook/:email?"
        token={token}
        savagent={roles.savagent}
      />
      <LoveboxInfoRouter
        exact
        path="/lovebox/"
        token={token}
        savagent={roles.savagent}
        loveboxBatchManager={roles.loveboxBatchManager}
      />
      <LoveboxInfoRouter
        exact
        path="/lovebox/pairing/:pairing?/"
        token={token}
        savagent={roles.savagent}
        loveboxBatchManager={roles.loveboxBatchManager}
      />
      <LoveboxInfoRouter
        exact
        path="/lovebox/macAddress/:macAddress?/"
        token={token}
        savagent={roles.savagent}
        loveboxBatchManager={roles.loveboxBatchManager}
      />
      <LoveboxInfoRouter
        exact
        path="/lovebox/:email?/:box?/"
        token={token}
        savagent={roles.savagent}
        loveboxBatchManager={roles.loveboxBatchManager}
      />
      <KeepDashboardRouter
        exact
        path="/keep/dashboard"
        token={token}
        savagent={roles.savagent}
      />
      <KeepInfoRouter
        exact
        path="/keep/:by(email|uid|pairing)?/:value?"
        token={token}
        savagent={roles.savagent}
      />
      <Authenticated
        path="/macAddress/:macAddress?/:tab?"
        component={SAVLovebox}
        token={token}
      />
      <Authenticated
        path="/pairing/:pairing?/:tab?"
        component={SAVLovebox}
        token={token}
      />
      <Authenticated
        path="/:email?/:box?/:tab?"
        component={SAVLovebox}
        token={token}
      />

      <Route render={() => (<div> Sorry, this page does not exist. </div>)} />
    </Switch>
  </Router>
);

export default RouterSAV;



// WEBPACK FOOTER //
// ./src/router/router.js